import { createClient } from '@supabase/supabase-js'

const COOKIE_DOMAIN = '.beautyhub.com.ar'

// Custom storage adapter que usa cookies compartidas entre subdominios
export const cookieStorage = {
  getItem: (key: string) => {
    if (typeof document === 'undefined') return null
    const match = document.cookie.match(new RegExp(`(^| )${key}=([^;]+)`))
    return match ? decodeURIComponent(match[2]) : null
  },
  setItem: (key: string, value: string) => {
    if (typeof document === 'undefined') return
    document.cookie = `${key}=${encodeURIComponent(value)}; Path=/; Domain=${COOKIE_DOMAIN}; SameSite=Lax; Secure; Max-Age=${60 * 60 * 24 * 30}` // 30 días
  },
  removeItem: (key: string) => {
    if (typeof document === 'undefined') return
    document.cookie = `${key}=; Path=/; Domain=${COOKIE_DOMAIN}; SameSite=Lax; Secure; Max-Age=0`
  },
}

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      storage: cookieStorage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
)